function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.444 24.5H4.667v-17h3.777v1.889H6.556V22.61h1.888zm6.816-14.17l-4.454 11.337h1.821l.907-2.43h5.061l.907 2.43h1.822L16.879 10.33h-1.62zm.809 2.162l1.927 5.126h-3.854l1.927-5.126zm9.375 10.119V9.39h-1.888V7.5h3.777v17h-3.777v-1.889z",
  fill: "#4A4A4A"
})));